







import {Vue, Component} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import Dispatch from './Dispatch.vue';

@Component({
  components: {
    PageTitle,
    AdminIframe,
    Dispatch
  }
})
export default class MailIframe extends Vue {
  
  private get remoteSrc() {
    const queryObject = { ...this.$route.query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    const src = process.env.VUE_APP_ADMIN_REMOTE_URL + '/member/email/manage?' + queryString;

    return src;
  }
}
